// extracted by mini-css-extract-plugin
export default {"gallery":"SectionGallery_gallery__EcUwH"};